"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidPhoneNumber = exports.formatPhoneNumber = exports.getFullFormattedPhoneNumber = exports.parsePhoneNumber = void 0;
const max_1 = __importStar(require("libphonenumber-js/max"));
const countries_1 = require("./countries");
function parsePhoneNumber(phone) {
    if (!phone)
        return {};
    const phoneObject = (0, max_1.default)(phone);
    return {
        phoneCode: `+${(phoneObject === null || phoneObject === void 0 ? void 0 : phoneObject.countryCallingCode) || ''}`,
        phoneNumber: phoneObject === null || phoneObject === void 0 ? void 0 : phoneObject.nationalNumber,
        countryCode: (phoneObject === null || phoneObject === void 0 ? void 0 : phoneObject.country) ||
            (0, countries_1.getCountryCodeByPhoneCode)(`+${phoneObject === null || phoneObject === void 0 ? void 0 : phoneObject.countryCallingCode}`),
    };
}
exports.parsePhoneNumber = parsePhoneNumber;
/**
 * Formats a phone number with country calling code.
 * Example: "+1 234567890"
 */
function getFullFormattedPhoneNumber(countryCode, phoneNumber) {
    if (!phoneNumber)
        return '';
    const phoneObject = (0, max_1.default)(phoneNumber, countryCode);
    return phoneObject
        ? `+${phoneObject === null || phoneObject === void 0 ? void 0 : phoneObject.countryCallingCode} ${(phoneObject === null || phoneObject === void 0 ? void 0 : phoneObject.nationalNumber) || phoneNumber}`
        : phoneNumber;
}
exports.getFullFormattedPhoneNumber = getFullFormattedPhoneNumber;
/**
 * Formats a phone number based on the provided options.
 * Example: "234-567-890" or "+1 234-567-890" (intl)
 */
function formatPhoneNumber(phoneNumber, options) {
    if (!phoneNumber)
        return '';
    const phoneObject = (0, max_1.default)(phoneNumber, options === null || options === void 0 ? void 0 : options.countryCode);
    if (options === null || options === void 0 ? void 0 : options.intl)
        return (phoneObject === null || phoneObject === void 0 ? void 0 : phoneObject.format('INTERNATIONAL')) || phoneNumber;
    return ((phoneObject === null || phoneObject === void 0 ? void 0 : phoneObject.format('NATIONAL', { nationalPrefix: false })) || phoneNumber);
}
exports.formatPhoneNumber = formatPhoneNumber;
function isValidPhoneNumber(phoneNumber, countryCode) {
    if (!phoneNumber)
        return false;
    return (0, max_1.isValidPhoneNumber)(phoneNumber, countryCode);
}
exports.isValidPhoneNumber = isValidPhoneNumber;
//# sourceMappingURL=phone.js.map